import AgGridMixin from './ag-grid.mixin';

export default {
  mixins: [AgGridMixin],
  props: {
    cargando: {
      type: Boolean,
      required: true,
    },
  },
};
